export const marketingCampaignConfig = {
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_campaign: 'utm_campaign',
    utm_term: 'utm_term',
    utm_content: 'utm_content',
};

export const getMarketingUrlParams = ({ queryParams = {} }) =>
    Object.keys(queryParams).reduce(
        (values, param) => ({
            ...values,
            [param]: marketingCampaignConfig[param] ? queryParams[param] : undefined,
        }),
        {},
    );

export const urlContainsMarketingParams = (queryParams) =>
    Object.keys(queryParams).includes(marketingCampaignConfig.utm_source);
